import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { detectPlayApp } from './utils/playApp';

detectPlayApp(); // antes do app limpar o endereço (?app=play)

// 📲 Guarda o convite de instalação do Android (chega antes da tela montar)
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__installPrompt = e;
  window.dispatchEvent(new Event('install-available'));
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => console.error('Service worker:', err));
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
